import React, { useState } from 'react';
import styles from './index.module.scss';
import { Track } from '../../../models/tracks/track';

type Props = {
  tracks: Track[];
};

const Report = (props: Props) => {
  const [expandedGroup, setExpandedGroup] = useState<string>('');
  const [expandedTrack, setExpandedTrack] = useState<string>('');

  const getTracksTotal = () => {
    return props.tracks.reduce((acc, track) => {
      const keys = ['fat', 'carb', 'prot', 'kcal'];
      return keys.map((key) => {
        const current = acc.find((item) => item.key === key);
        return {
          key: key,
          value: (current ? +current.value : 0) + +track.getTotal(key),
        };
      });
    }, []);
  };

  return (
    <>
      <div className={styles.report_wrapper}>
        {props.tracks.map((track, i) => {
          return (
            <div className={styles.item_wrapper}>
              <div className={styles.stats}>
                <div className={styles.top}>
                  {track.getStats().map((stat) => {
                    return (
                      <div className={styles.column}>
                        <div className={styles.row}>
                          <span>{stat.key}</span>
                        </div>
                        <div className={styles.row}>{stat.value}</div>
                      </div>
                    );
                  })}
                </div>
                <div className={styles.bottom}>
                  <div className={styles.left}>Day {i + 1}</div>
                  <div
                    className={`${styles.right} ${
                      expandedTrack === track._id ? styles.right_expanded : ''
                    }`}
                    onClick={() =>
                      setExpandedTrack(
                        expandedTrack !== track._id ? track._id : '',
                      )
                    }
                  >
                    more
                  </div>
                </div>
              </div>
              <div
                className={`${styles.meal_groups} ${
                  expandedTrack === track._id ? styles.meal_groups_expanded : ''
                }`}
              >
                {track.mealGroups.map((mealGroup) => {
                  return (
                    <div className={styles.meal_group}>
                      <div className={styles.meal_group_header}>
                        <div>{mealGroup.value}</div>
                        <div>Fat</div>
                        <div>Carb</div>
                        <div>prot</div>
                        <div>kcal</div>
                        <div />
                      </div>
                      <div
                        className={`${styles.meal_group_body} ${
                          expandedGroup === mealGroup._id
                            ? styles.expanded_group
                            : ''
                        }`}
                      >
                        {mealGroup.meals.map((meal) => {
                          return (
                            <div className={styles.meal_group_body_item}>
                              <div>
                                {meal.name} <br />
                                <span>
                                  {meal.count} {meal.measurement}
                                </span>
                              </div>
                              <div>{meal.calculate('fat')}</div>
                              <div>{meal.calculate('carb')}</div>
                              <div>{meal.calculate('prot')}</div>
                              <div>{meal.calculate('kcal')}</div>
                              <div />
                            </div>
                          );
                        })}
                      </div>
                      <div
                        className={`${styles.meal_group_footer} ${
                          expandedGroup === mealGroup._id
                            ? styles.meal_group_footer_expanded
                            : ''
                        }`}
                      >
                        <div>Total:</div>
                        <div>{mealGroup.getTotal('fat')}</div>
                        <div>{mealGroup.getTotal('carb')}</div>
                        <div>{mealGroup.getTotal('prot')}</div>
                        <div>{mealGroup.getTotal('kcal')}</div>
                        <div
                          onClick={() =>
                            setExpandedGroup(
                              expandedGroup !== mealGroup._id
                                ? mealGroup._id
                                : '',
                            )
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.total_stat}>
        <div className={styles.column}>
          <div className={styles.row}></div>
          <div className={styles.row}>Total: </div>
        </div>
        {getTracksTotal().map((item) => {
          return (
            <div className={styles.column}>
              <div className={styles.row}>{item.key}</div>
              <div className={styles.row}>{item.value}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Report;
